import { useIdentityContext } from '@dark-portal/frontend-identity';
import { useEffect } from 'react';

import { useWebsocketStore } from '@/src/features/app/store/websocket/store';

export function WebsocketConnector() {
  const user = useIdentityContext((state) => state.user);
  const connect = useWebsocketStore((state) => state.connect);
  const disconnect = useWebsocketStore((state) => state.disconnect);

  useEffect(() => {
    if (user) {
      void connect();
    } else {
      disconnect();
    }
  }, [user]);

  return null;
}
